import { userRoles } from 'apis/users';
import { userHasRole } from '../userHasRole';
const currentUserRoleKeyPrefix = 'atLeast';
/**
 * Checks a user against all possible user roles and returns which roles the
 * user does and does not belong to.
 *
 * @param user The user object.
 */
export function currentUserRole(user) {
    return userRoles.reduce((roles, role) => (Object.assign(Object.assign({}, roles), { [`${currentUserRoleKeyPrefix}${role.charAt(0).toUpperCase()}${role.slice(1)}`]: userHasRole(user, role) })), {});
}
